import { apiCall } from '../api';
import type { MenuRatingSummary } from '@/types/api';

export async function fetchMenuRatings(menuIds: number[]) {
  return apiCall<{ ratingsByMenuId: Record<number, MenuRatingSummary> }>(
    `/api/feedback/ratings?menuIds=${menuIds.join(',')}`
  );
}

export async function updateMenuRating(menuId: number, rating: number | null) {
  return apiCall<MenuRatingSummary & { menuId: number }>('/api/feedback/ratings', {
    method: 'PUT', body: JSON.stringify({ menuId, rating }),
  });
}
